// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2f464aad","453":"bd95ecc0"}[chunkId] + ".chunk.js";
};